import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../imgs/logo.svg';

function navigations() {
  return (
     <Navbar collapseOnSelect expand="lg" >
        <Container>
            <div className='d-inline-flex justify-content-between rounded-5 box-shadow w-100 bg-light px-4 pe-2'>
            <Navbar.Brand className='me-4 logo' href="#home"><img className='w-75' src={logo} alt="Hero Section Image" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
            <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
                <Nav.Link href="#home">Home</Nav.Link>
                <Nav.Link href="#about">About</Nav.Link>
                <NavDropdown title="Services" id="collapsible-nav-dropdown">
                    <NavDropdown.Item href="#web-development">Web Development</NavDropdown.Item>
                    <NavDropdown.Item href="#mobile-apps">Mobile Applications</NavDropdown.Item>
                    <NavDropdown.Item href="#cloud-services">Cloud Services</NavDropdown.Item>
                    <NavDropdown.Item href="#cyber-security">Cyber Security</NavDropdown.Item>
                    <NavDropdown.Item href="#it-consulting">IT Consulting</NavDropdown.Item>
                    <NavDropdown.Item href="#data-analytics">Data Analytics</NavDropdown.Item>
                    <NavDropdown.Item href="#ui-ux-design">UI/UX Design</NavDropdown.Item>
                    <NavDropdown.Item href="#support">Technical Support</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="#membership">Membership</Nav.Link>
                <Nav.Link href="#contact">Contact</Nav.Link>
            </Nav>
            <Nav>
                <Nav.Link className='btn btn-primary rounded-5 px-5 text-light' href="#deets">Get In Touch</Nav.Link>
            </Nav>
            </Navbar.Collapse>
            </div>
        </Container>
        </Navbar>
  )
}

export default navigations
